import { useLayoutEffect, useRef } from 'react'

/** A ref that always holds the latest value, for callbacks that must not
 *  re-subscribe on every render. Written after commit, read in handlers. */
export function useLatest<T>(value: T) {
  const ref = useRef(value)
  useLayoutEffect(() => { ref.current = value })
  return ref
}
